<div
  class="row gy-4 justify-content-center row-cols-lg-3"
  [class.single-row-scroll-container]="
    singleRowScrollable && proposals?.length > 0
  "
>
  <div
    class="col"
    [class.single-row-scroll-col]="singleRowScrollable"
    *ngFor="let offer of proposals; trackBy: trackByProposalId"
  >
    <app-proposal-displayer
      [offer]="offer"
      [showViewIcon]="showViewIcon"
      (editProposal)="editProposal.emit($event)"
      (deleteProposal)="onDeleteProposal($event)"
      (sendProposal)="onSendProposal($event)"
      (viewDocument)="viewFile($event)"
    />
  </div>

  <p *ngIf="proposals.length == 0" style="text-align: center" i18n>
    Aucune offre n'a été faite.
  </p>
</div>

<app-action-modal
  #deletionModal
  [disabled]="submitted"
  (submitted)="submitDeleteProposal()"
>
  <ng-container mainTitle i18n>Supprimer cette offre ?</ng-container>
  <ng-container subtitle i18n>Cette action est irréversible</ng-container>
  <ng-container submitButtonLabel i18n>Supprimer</ng-container>
</app-action-modal>

<app-pdf-viewer-modal #pdfViewer />
<app-add-proposal-modal
  [leadId]="leadId"
  #editProposalModal
  (proposalAdded)="proposalsChanged.emit()"
  [preload]="false"
/>

<app-action-modal
  #sendModal
  [disabled]="submitted"
  submitButtonClass="lty-btn-primary"
  (submitted)="submitSendProposal()"
  size="md"
  headerIconState="success"
  [showHeader]="true"
>
  <div class="proposals-send-icon" headerIcon>
    <app-check-circle-outline-icon
      height="16px"
      width="16px"
      color="var(--success-500)"
    />
  </div>
  <ng-container mainTitle i18n>Envoyer cette offre ?</ng-container>
  <label class="form-check d-flex align-items-center ps-0 gap-2 mt-2" subtitle>
    <input
      type="checkbox"
      class="form-check-input m-0"
      [(ngModel)]="withoutNotification"
    />
    <span class="form-check-label m-0" i18n>Sans notification</span>
  </label>
  <ng-container submitButtonLabel i18n>Envoyer</ng-container>
</app-action-modal>
